export default "__VITE_ASSET__CAtghIyK__"